

























import { $store } from "@/store";
import { Vue, Component } from "vue-property-decorator";
import { $appearance } from "../../store/appearance/store";
import LayoutInsertDetails from "./LayoutInsertDetails.vue";
import LayoutInsertList from "./LayoutInsertList.vue";

@Component({
  components: {
    "ag-layout-insert-list": LayoutInsertList,
    "ag-layout-insert-details": LayoutInsertDetails,
  },
})
export default class LayoutTools extends Vue {
  get hideInsertDetails() {
    return $appearance.hideInsertDetails;
  }

  get currentPage() {
    return $store.wizard.layoutPage;
  }

  get inserts() {
    return $store.layouts.layout.inserts;
  }

  get selectedInsert() {
    return $store.wizard.selectedInsert;
  }

  get toolbarHeight() {
    return `${$store.appearance.PDFVIEWERTOOLBAR_HEIGHT - 60}px`;
  }

  get insertListHeight() {
    return `${$store.appearance.PDFVIEWERTOOLBAR_HEIGHT - 70}px`;
  }

  get showInsertList() {
    return (
      $store.wizardInstances.wizardInstance?.config.layout?.flow === "admin" ||
      ($store.wizardInstances.wizardInstance?.config.layout?.predefinedInserts
        ?.length || 0) > 1
    );
  }

  addLayoutInsert() {
    $store.layouts.addInsert(this.currentPage);
  }

  removeLayoutInsert(ind: number) {
    $store.layouts.removeInsert(ind);
  }
}
